module.exports = __webpack_public_path__ + "static/img/global_down_arrow@3x.d8120e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_down_arrow@3x.png
// module id = YzXe
// module chunks = 1